<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("SettingBot.topic") }}</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title>
                <v-layout row wrap>
                  <v-flex xs10 lg3 ml-3>
                    <v-btn color="#077893" outlined to="/config-bot-add">
                      <v-icon class="mr-1">mdi-plus</v-icon>
                      {{ $t("SettingBot.addbot") }}
                    </v-btn>
                    <br />
                    <br />
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6 lg4>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="mt-n4">
                <v-card outlined>
                  <v-data-table
                    class="ellipsis"
                    :headers="headers"
                    :items="ItemPolicy"
                    :search="Search"
                    hide-default-footer
                    :page.sync="Page"
                    @page-count="PageCount = $event"
                    :items-per-page="ItemPerPage"
                  >
                    <template v-slot:[`item.Name`]="{ item }">
                      <div class="text-truncate" style="max-width: 300px">
                        {{ item.Name }}
                      </div>
                    </template>
                    <template v-slot:[`item.BotId`]="{ item }">
                      <v-tooltip content-class="wide-tooltip" top>
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-icon
                              v-on="on"
                              v-bind="attrs"
                              style="cursor: pointer"
                              @click="handleCopyClick(item.BotId)"
                              color="#077893"
                              :key="iconState[item.Id] || 'copy'"
                              class="icon-transition"
                            >
                              {{
                                iconState[item.BotId] === "copied"
                                  ? "mdi mdi-check"
                                  : "mdi mdi-content-copy"
                              }}
                            </v-icon>
                          </div>
                        </template>
                        <span>Copy</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:[`item.ChatAuth`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <div>
                            <v-icon
                              v-on="on"
                              v-bind="attrs"
                              style="cursor: pointer"
                              @click="
                                handleCopyClickAuthChat(
                                  item.ChatAuth,
                                  item.BotId
                                )
                              "
                              color="#077893"
                              :key="`${item.BotId}-${item.ChatAuth}`"
                              class="icon-transition"
                            >
                              {{
                                iconStateAuthChat[
                                  `${item.BotId}-${item.ChatAuth}`
                                ] === "copied"
                                  ? "mdi mdi-check"
                                  : "mdi mdi-content-copy"
                              }}
                            </v-icon>
                          </div>
                        </template>
                        <span>Copy</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:[`item.Status`]="{ item }">
                      <div>
                        <v-chip
                          v-if="item.Status"
                          class="ma-2"
                          color="success"
                          outlined
                        >
                          Active
                        </v-chip>
                        <v-chip v-else class="ma-2" color="red" outlined>
                          InActive
                        </v-chip>
                      </div>
                    </template>
                    <template v-slot:[`item.CreatedAt`]="{ item }">
                      <div>
                        {{ formatDate(item.CreatedAt) }}
                      </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-menu offset-y>
                        <template v-slot:activator="{ attrs, on }">
                          <v-btn
                            dark
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mx-2"
                            fab
                            color="#077893"
                          >
                            <v-icon dark size="20">
                              mdi-format-list-bulleted-square
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list v-for="(list, i) in itemsAction" :key="i" dense>
                          <v-list-item
                            @click="fn_checkActionType(list.service, item)"
                            link
                          >
                            <v-list-item-icon class="mr-3">
                              <v-icon :color="list.color"
                                >{{ list.icon }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-title
                              v-if="$t('default') === 'th'"
                              :inner-text.prop="list.text"
                              style="font-size: 14px"
                            ></v-list-item-title>
                            <v-list-item-title
                              v-else
                              :inner-text.prop="list.text2"
                              style="font-size: 14px"
                            ></v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </template>
                  </v-data-table>
                </v-card>
                <v-pagination
                  :total-visible="7"
                  class="pt-2 pb-2"
                  circle
                  color="#077893"
                  v-model="Page"
                  :length="PageCount"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                >
                </v-pagination>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <DialogDeleteBot
        :show="DialogDelete"
        :_item="ItemDelete"
        @closeDialogDelete="DialogDelete = false"
        @reData="Fn_GetAllBot()"
      />
      <div v-if="isLoading">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
// import DialogDeleteBot from "@/components/dialog/BotOnePlatform/SettingBot/DialogDeleteBot.vue";
import DialogDeleteBot from "@/components/dialog/BotOnePlatform/SettingBot/DialogDeleteBot.vue";
import moment from "moment";
import "moment/locale/th"; // สำหรับภาษาไทย

export default {
  components: {
    DialogDeleteBot,
    OverlaySearch,
  },
  data() {
    return {
      Search: "",
      Page: 1,
      PageCount: 0,
      ItemPerPage: 10,
      isLoading: true,
      DialogDelete: false,
      iconState: {},
      iconStateAuthChat: {},
      ItemDelete: [],
      ItemPolicy: [
        {
          no: 1,
          BotId: "bot-123",
          Name: "บอททดสอบ 1",
          ChatAuth: "Token123",
          Status: "Active",
          CreatedAt: "2023-10-27 10:00:00",
          CreatedBy: "user1",
        },
        {
          no: 2,
          BotId: "bot-456",
          Name: "บอททดสอบ 2",
          ChatAuth: "Token456",
          Status: "Inactive",
          CreatedAt: "2023-10-26 15:30:00",
          CreatedBy: "user2",
        },
      ],
      itemsAction: [
        {
          icon: "mdi-pencil",
          text: "แก้ไขข้อมูล",
          text2: "Edit",
          color: "orange",
          service: "Edit",
        },
        {
          icon: "mdi-trash-can",
          text: "ลบข้อมูล",
          text2: "Delete",
          color: "red",
          service: "Del",
        },
      ],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          value: "no",
          sortable: false,
          align: "center",
        },
        {
          text: "Bot ID",
          value: "BotId",
          align: "center",
          sortable: false,
        },
        {
          text: "ชื่อบอท",
          value: "Name",
          align: "center",
          sortable: false,
        },
        {
          text: "Chat Auth",
          align: "center",
          value: "ChatAuth",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          value: "Status",
          sortable: false,
        },
        {
          text: "วันที่สร้าง",
          value: "CreatedAt",
          align: "center",
          sortable: false,
        },
        {
          text: "ผู้สร้าง",
          value: "CreatedBy",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.choice"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
  mounted() {
    this.Fn_GetAllBot();
    // Add any mounted lifecycle hooks you need here
  },
  methods: {
    handleCopyClick(id) {
      // ตั้งค่าสถานะเป็น 'copied' สำหรับไอคอนนี้
      this.Fn_CopyDetail(id);
      this.$set(this.iconState, id, "copied");

      // หลังจาก 2 วินาที เปลี่ยนกลับเป็นไอคอนเดิม
      setTimeout(() => {
        this.$set(this.iconState, id, "copy");
      }, 1200);
    },
    async Fn_CopyDetail(Id) {
      await navigator.clipboard.writeText(Id);
    },
    handleCopyClickAuthChat(id, bot_id) {
      const compositeKey = `${bot_id}-${id}`;
      this.Fn_CopyDetailAuthChat(id);
      this.$set(this.iconStateAuthChat, compositeKey, "copied");

      setTimeout(() => {
        this.$set(this.iconStateAuthChat, compositeKey, "copy");
      }, 1200);
    },
    async Fn_CopyDetailAuthChat(Id) {
      await navigator.clipboard.writeText(Id);
    },
    formatDate(dateString) {
      if (!dateString) return "-"; // หรือ return ค่าเริ่มต้นอื่นๆ ตามต้องการ
      return moment(dateString).locale("th").format("DD MMM YYYY HH:mm:ss");
    },
    truncateText(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    fn_checkActionType(service, item) {
      if (service === "Edit") {
        // store item and go edit page
        this.$store.dispatch("SET_UPDATE_BOT", item);
        this.$router.push("/config-bot-update");
      } else {
        this.Fn_Delete(item);
      }
    },
    async Fn_GetAllBot() {
      var biz_id = this.$cookies.get("BusinessId");
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);
      var headers = {
        Authorization: "Bearer " + auth,
        "Access-Control-Allow-Origin": "*",
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      };
      this.axios
        .get(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            `onechat/Bot/${biz_id}?Name=${this.Search}`,
          {
            headers,
          }
        )
        .then((response) => {
          this.ItemPolicy = response.data.Message;
          this.ItemPolicy = this.ItemPolicy.map((item, index) => ({
            ...item, // กระจาย properties เดิมทั้งหมด
            no: index + 1, // เพิ่ม property no โดยเริ่มจาก 1
          }));
          // this.tableload = false;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_Delete(item) {
      this.DialogDelete = true;
      this.ItemDelete = item;
      this.axios
        .delete(
          process.env.VUE_APP_API_FACTORING_SERVICE + `onechat/Bot/${BotId}`,
          {
            headers,
          }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.Fn_GetAllBot();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wide-tooltip {
  max-width: 400px !important;
  width: auto !important;
  font-size: 14px;
  line-height: 1.4;
}
</style>
